// Core types. Unico input del giocatore = numero di tocchi -> ogni prova
// si risolve in un intero 0..ANSWER_MAX. Memoria a FINESTRA (non cumulativa).

export type Category = string; // usata come "famiglia" dallo scheduler

export interface Trial {
  id: string;
  category: string; // famiglia (simple|reason|observe|recall|combo|condition|attention)
  prompt: string;
  speech: string;
  requiredTaps: number; // 0..ANSWER_MAX
  explanation?: string;
  // Canale di render strutturato OPZIONALE (Stroop/pattern colorati). Se assente,
  // il prompt viene mostrato come testo semplice (comportamento invariato).
  render?: RenderSegment[];
}

// Segmento di rendering: testo con colore/dimensione opzionali (interferenza visiva).
export interface RenderSegment {
  t: string;
  c?: string; // colore CSS
  s?: number; // dimensione relativa (em)
}

// Un filo di osservazione: token mostrati (animali/colori/forme) da richiamare.
export interface SeenThread {
  kind: "animal" | "color" | "shape";
  order: { key: string; name: string }[]; // sequenza mostrata
  counts: Record<string, number>;
  total: number;
  plantTurn: number;
  dueTurn: number; // richiamo previsto (4..6)
  resolved: boolean;
}

export interface NumberThread {
  value: number;
  plantTurn: number;
  dueTurn: number;
  resolved: boolean;
}

export interface GameMemory {
  turn: number;
  threads: SeenThread[];
  numberThread: NumberThread | null;
  lastFamily: string | null;
  sinceSimple: number; // turni dall'ultimo "simple" (per il respiro)
  lastZeroTap: boolean; // il turno precedente richiedeva 0 tocchi (passivo)?
  recentSurfaces: string[]; // ultime superfici/template emesse (anti-repeat percepito)
  recentKinds: string[]; // ultimi kind (animal/color/shape) usati (rotazione contenuti)
  ruleToggle: number; // contatore per alternare le regole (task-switch)
}

export function createGameMemory(): GameMemory {
  return {
    turn: 0,
    threads: [],
    numberThread: null,
    lastFamily: null,
    sinceSimple: 99,
    lastZeroTap: false,
    recentSurfaces: [],
    recentKinds: [],
    ruleToggle: 0,
  };
}

export function isCorrect(trial: Trial, taps: number): boolean {
  return taps === trial.requiredTaps;
}

export const ANSWER_MAX = 8;
